import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .ChangeStatusButton {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 32px;

    &__caption {
      font-size: 12px;
      color: #999;
      text-decoration: underline;
    }

    &__icon-wrapper {
      svg {
        path {
          stroke: #999;
        }
      }

      &-collapsed {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    &__button {
      margin-top: 12px;
      border-color: #f2b233;

      .DefaultButton__text {
        color: #333;
      }
    }
  }

  .ChangePaymentStatusModal {
    h2 {
      text-align: center;
    }

    :global(.ReactModal__Content) {
      max-width: 738px !important;
      width: 100%;
    }
  }
`;
